(() => {
  const KEY = 'al-imran-favourites';
  const DATA_KEY = 'al-imran-favourite-products';
  const parse = (value, fallback) => { try { return JSON.parse(value) } catch (_) { return fallback } };
  const handles = () => parse(localStorage.getItem(KEY) || '[]', []);
  const data = () => parse(localStorage.getItem(DATA_KEY) || '{}', {});
  const save = (list, products) => {
    localStorage.setItem(KEY, JSON.stringify(list));
    localStorage.setItem(DATA_KEY, JSON.stringify(products));
  };
  const productFromButton = (button, handle) => {
    const card = button.closest('.catalogue-card-styled, [data-card]');
    const link = card && Array.from(card.querySelectorAll('a[href*="/products/"]')).find(a => a.getAttribute('href'));
    const image = card && card.querySelector('.card__media img, img');
    return {
      handle: handle,
      title: button.dataset.productTitle || (link && link.textContent.trim()) || (image && image.alt.trim()) || handle.replaceAll('-', ' '),
      url: button.dataset.productUrl || (link && link.href) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + handle,
      image: button.dataset.productImage || (image && (image.currentSrc || image.src)) || ''
    };
  };
  const getHandle = card => {
    const link = Array.from(card.querySelectorAll('a[href*="/products/"]')).find(a => a.getAttribute('href'));
    const match = link && link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return (match && match[1]) || '';
  };
  const heartMarkup = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.7-7.5 1.1-1.1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const updateButtons = () => {
    const saved = handles();
    document.querySelectorAll('[data-ais-favourite]').forEach(button => {
      const active = saved.includes(button.dataset.aisFavourite);
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from favourites' : 'Add to favourites');
    });
    document.querySelectorAll('[data-favourites-count]').forEach(node => node.textContent = String(saved.length));
  };
  const scanCards = root => {
    (root || document).querySelectorAll('.catalogue-card-styled').forEach(card => {
      if (card.querySelector('[data-ais-favourite]') || card.querySelector('.pna__heart')) return;
      const handle = getHandle(card);
      if (!handle) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ais-favourite-button';
      button.dataset.aisFavourite = handle;
      button.innerHTML = heartMarkup;
      card.appendChild(button);
    });
    updateButtons();
  };
  const renderDrawer = () => {
    const list = handles();
    const products = data();
    const host = document.querySelector('[data-favourites-list]');
    const empty = document.querySelector('[data-favourites-empty]');
    if (!host || !empty) return;
    host.replaceChildren();
    list.forEach(handle => {
      const product = products[handle] || {handle:handle, title:handle.replaceAll('-', ' '), url:'/products/' + handle, image:''};
      const item = document.createElement('div');
      item.className = 'ais-favourite-item';
      const imageHtml = product.image ? '<img src="' + product.image + '" alt="">' : '<span></span>';
      item.innerHTML = imageHtml + '<a href="' + product.url + '">' + product.title + '</a><button type="button" data-favourite-remove="' + handle + '" aria-label="Remove ' + product.title + '">×</button>';
      item.querySelector('[data-favourite-remove]').addEventListener('click', () => {
        const nextList = handles().filter(itemHandle => itemHandle !== handle);
        const nextProducts = data();
        delete nextProducts[handle];
        save(nextList, nextProducts);
        renderDrawer();
        updateButtons();
      });
      host.appendChild(item);
    });
    empty.hidden = list.length > 0;
  };
  const openDrawer = () => {
    renderDrawer();
    const drawer = document.getElementById('AisFavouritesDrawer');
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('ais-drawer-open');
  };
  const closeDrawer = () => {
    const drawer = document.getElementById('AisFavouritesDrawer');
    if (drawer) drawer.hidden = true;
    document.body.classList.remove('ais-drawer-open');
  };
  document.querySelectorAll('[data-favourites-close]').forEach(button => button.addEventListener('click', closeDrawer));
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-favourites-open]');
    if (open) { event.preventDefault(); openDrawer(); return }
    if (event.target.closest('[data-favourites-close]')) { closeDrawer(); return }
    const remove = event.target.closest('[data-favourite-remove]');
    if (remove) {
      const list = handles().filter(handle => handle !== remove.dataset.favouriteRemove);
      const products = data();
      delete products[remove.dataset.favouriteRemove];
      save(list, products); renderDrawer(); updateButtons(); return;
    }
    const button = event.target.closest('[data-ais-favourite]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.aisFavourite;
    let list = handles();
    const products = data();
    if (list.includes(handle)) {
      list = list.filter(item => item !== handle);
      delete products[handle];
    } else {
      list.push(handle);
      products[handle] = productFromButton(button, handle);
    }
    save(list, products); updateButtons(); renderDrawer();
  });
  document.addEventListener('click', event => {
    const legacy = event.target.closest('.pna__heart[data-fav]');
    if (!legacy) return;
    setTimeout(() => {
      const handle = legacy.dataset.fav;
      const list = handles();
      const products = data();
      if (list.includes(handle)) products[handle] = productFromButton(legacy, handle);
      else delete products[handle];
      save(list, products); updateButtons();
    }, 0);
  });
  const notice = document.getElementById('AisPaymentNotice');
  let pending = null;
  let bypass = false;
  let paymentTrigger = null;
  const showNotice = action => {
    pending = action;
    paymentTrigger = document.activeElement;
    if (!notice) return;
    notice.hidden = false;
    document.body.classList.add('ais-payment-open');
    requestAnimationFrame(() => notice.querySelector('[data-payment-continue]')?.focus());
  };
  const hideNotice = () => {
    if (notice) notice.hidden = true;
    document.body.classList.remove('ais-payment-open');
    pending = null;
    if (paymentTrigger && typeof paymentTrigger.focus === 'function') paymentTrigger.focus();
    paymentTrigger = null;
  };
  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    if (bypass || !(submitter && (submitter.name === 'checkout' || submitter.id === 'CartDrawer-Checkout'))) return;
    event.preventDefault();
    showNotice(() => {
      bypass = true;
      event.target.requestSubmit(submitter);
      setTimeout(() => { bypass = false }, 0);
    });
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="/checkout"]');
    if (!link || bypass) return;
    event.preventDefault();
    showNotice(() => { bypass = true; window.location.assign(link.href) });
  }, true);
  document.querySelectorAll('[data-payment-cancel]').forEach(button => button.addEventListener('click', hideNotice));
  const continueButton = document.querySelector('[data-payment-continue]');
  if (continueButton) continueButton.addEventListener('click', () => {
    const action = pending;
    if (notice) notice.hidden = true;
    document.body.classList.remove('ais-payment-open');
    pending = null;
    paymentTrigger = null;
    if (action) action();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && notice && !notice.hidden) hideNotice();
  });
  scanCards();
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scanCards(node);
  }))).observe(document.body, {childList:true, subtree:true});
  window.addEventListener('pageshow', () => { scanCards(); updateButtons() });
})();

(() => {
  const salesmen = Object.freeze({
    imran: { name: 'Imran', code: 'SM01' },
    aftab: { name: 'Aftab', code: 'SM02' },
    owais: { name: 'Owais', code: 'SM03' },
    sakib: { name: 'Sakib', code: 'SM04' },
    saif: { name: 'Saif', code: 'SM05' },
    shameem: { name: 'Shameem', code: 'SM06' },
    kaif: { name: 'Kaif', code: 'SM07' },
    huzefa: { name: 'Huzefa', code: 'SM08' },
    gulam: { name: 'Gulam', code: 'SM09' },
    hamza: { name: 'Hamza', code: 'SM10' }
  });

  const params = new URLSearchParams(window.location.search);
  const referralKey = (params.get('salesman') || '').trim().toLowerCase();
  const salesman = salesmen[referralKey];

  window.AlImranSalesmanReferral = Object.freeze({
    salesmen,
    current: salesman ? { key: referralKey, ...salesman } : null
  });

  if (!salesman) return;

  const root = window.Shopify?.routes?.root || '/';
  const updateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;
  const referralUrl = new URL(window.location.href);
  referralUrl.search = '';
  referralUrl.hash = '';

  fetch(updateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'Salesman Name': salesman.name,
        'Salesman Code': salesman.code,
        'Salesman Referral': referralKey,
        'Referral Landing Page': referralUrl.toString()
      }
    })
  }).catch((error) => {
    console.error('Salesman referral could not be saved.', error);
  });
})();
